export enum InvoiceStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  ESTIMATE = "ESTIMATE",
  ESTIMATE_APPROVED = "ESTIMATE_APPROVED",
  ESTIMATE_REJECTED = "ESTIMATE_REJECTED",
  SENT = "SENT",
  PAID = "PAID",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
}
